import React from 'react'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
// core components

import GridContainer from 'components/Grid/GridContainer'
import GridItem from 'components/Grid/GridItem.js'

import HomeWorkIcon from '@material-ui/icons/HomeWork'

import styles from 'assets/jss/material-kit-react/views/servicePageSections/testStyle.js'
import Card from 'components/Card/Card'
import { CardActionArea } from '@material-ui/core'

const useStyles = makeStyles(styles)

const cardData = [
  { text: '噪声监测', icon: 'icon-zaoshengzhan' },
  { text: '照明系统节能', icon: 'icon-ledwarring' },
  { text: '室内空气质量', icon: 'icon-GAS' },
  { text: '氡浓度检测', icon: 'icon-tudi' },
  { text: '建筑声学', icon: 'icon-zidingyishengxuemoxing' },
  { text: '空调系统', icon: 'icon-kongtiao1' },
  { text: '电磁辐射', icon: 'icon-dianci' },
  { text: '水平衡测试', icon: 'icon-shuifei' },
]

export default function TestSection(props) {
  const classes = useStyles()
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>
            <HomeWorkIcon className={classes.titleIcon} />
            检测板块
          </h2>
        </GridItem>
      </GridContainer>
      <GridContainer justify="center">
        {cardData.map(item => {
          return (
            <GridItem xs={6} sm={6} md={3} key={item.text}>
              <Card>
                <CardActionArea className={classes.iconHeader}>
                  <svg className="icon" aria-hidden="true">
                    <use xlinkHref={`#${item.icon}`}></use>
                  </svg>
                </CardActionArea>
                <h4>{item.text}</h4>
              </Card>
            </GridItem>
          )
        })}
      </GridContainer>
    </div>
  )
}
